import { useState } from 'react';
import { NewsItemClient, NewsItemDTO, ApiResponse_string, SearchRequestDTO_NewsItemSearchRequestDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';
import { handleHookError } from '../utils/hookUtils/handleHookError';

export const useNewsItemApi = () => {
    const apiClient = new NewsItemClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: NewsItemDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createNewsItem(data);
        } catch (err: any) {
            setError(err.message || 'Error creating NewsItem');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: NewsItemDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateNewsItem(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating NewsItem');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getNewsItemById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching NewsItem');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchNewsItems(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching NewsItems');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteNewsItem(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting NewsItem');
        } finally {
            setIsLoading(false);
        }
    };

    const extract = async (
        filters: any
    ): Promise<ApiResponse_string> => {
        setIsLoading(true);
        try {
            return await apiClient.exportNewsItems(filters);
        } catch (err: unknown) {
            handleHookError(err, 'Error exporting NewsItems', setError);
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, extract, remove, isLoading, error };
};